
import { PublicClientApplication } from '@azure/msal-browser';

// Configuración MSAL usando las variables de entorno específicas
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '00000000-0000-0000-0000-000000000000',
    authority: process.env.REACT_APP_AZURE_AUTHORITY || 'https://login.microsoftonline.com/common',
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: process.env.REACT_APP_CACHE_LOCATION || 'sessionStorage',
    storeAuthStateInCookie: process.env.REACT_APP_STORE_AUTH_STATE_IN_COOKIE === 'true' || false,
  },
};

// Configuración del login request
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

// Configuración del Graph API usando tu variable
export const graphConfig = {
  graphMeEndpoint: process.env.REACT_APP_GRAPH_ME_ENDPOINT || 'https://graph.microsoft.com/v1.0/me',
};

// IMPORTANTE: Crear y exportar la instancia MSAL
export const msalInstance = new PublicClientApplication(msalConfig);